<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { App } from '@capacitor/app';

const router = useRouter();

// Handle Android hardware back button
onMounted(() => {
  App.addListener('backButton', ({ canGoBack }) => {
    if (!canGoBack) {
      // On root page - exit app
      App.exitApp();
    } else {
      // Navigate back in router
      router.back();
    }
  });
});
</script>


